import { CSSProperties } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { EmptyState } from '@ets/design-system';

import { useDispatch } from '_common/hooks';

import { FilterIdentity } from '../../FilterController';
import { clearFilterIdentity } from '../../FilterSlice';

import styles from './EmptyFilteredState.module.scss';

type EmptyFilteredStateProps = {
  margin?: CSSProperties['margin'];
  //If no identity set, clear button won't be rendered
  identity?: FilterIdentity;
  size?: 'm' | 'l';
  hideIcon?: boolean;
  message?: TranslationMessage;
  testId?: string;
};

const EmptyFilteredState = ({
  identity,
  size = 'l',
  margin = '8rem 0 0 0',
  hideIcon = false,
  message,
  testId,
}: EmptyFilteredStateProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleClearFilters = () => {
    if (identity) {
      dispatch(clearFilterIdentity({ identity }));
    }
  };

  return (
    <span className={styles.root} style={{ margin }}>
      <EmptyState
        size={size}
        cta={
          identity
            ? {
                variant: 'standard',
                children: intl.formatMessage({ id: 'CLEAR_FILTERS' }),
                onClick: handleClearFilters,
              }
            : undefined
        }
        title={intl.formatMessage({ id: 'NO_RESULTS_FOUND' })}
        icon={!hideIcon ? (size === 'l' ? 'magnifying-glass' : 'file') : undefined}
        testId={testId || `${identity ? `${identity}-` : ''}emptyFilteredState`}
        description={
          message ? (
            <FormattedMessage id={message.id} values={message.values} />
          ) : (
            <FormattedMessage id="NO_ELEMENTS_IN_SPACE_MATCHING_FILTERS_CLEAR_FILTERS" />
          )
        }
      />
    </span>
  );
};

export default EmptyFilteredState;
